import { SpreadProfileListSubscriber } from '@cbridge-packages/spread-profile';
import { ProfilesLayout } from '../../_layout/ProfilesLayout';

export const ProfilesSpreadLayout = () => (
  <ProfilesLayout>
    <SpreadProfileListSubscriber />
  </ProfilesLayout>
);
